/** For someone with too few messages for a story: a quiet card, then on to the chat's. */

import { Letters, Scene, Zone, type BlobSpec } from "../../story/stage";
import { useTimeline } from "../../story/timeline";
import type { Period } from "../../types";
import { lastDay, longDate } from "../shared";

const BLOBS: BlobSpec[] = [
  { colour: "blurple", x: 980, y: 300, r: 170, seed: 3.3, wob: 0.2 },
  { colour: "deep", x: 80, y: 1800, r: 320, seed: 5.1, wob: 0.16 },
];

const HEADLINE = "You were quiet this year";

export function NotAround({ period }: { period: Period }) {
  const root = useTimeline((s) => {
    s.rise("[data-part=kick]", 0.35, { y: 0 });
    s.letters("[data-part=headline]", 0.5, { y: 110, stagger: 0.03 });
    s.rise("[data-part=why]", 1.6, { y: 24, sound: false });
    s.rise("[data-part=period]", 2.0, { y: 0, sound: false });
  });

  return (
    <div ref={root} className="contents">
      <Scene blobs={BLOBS}>
        <Zone at="top">
          <div data-part="kick" className="kick" style={{ color: "var(--wr-yellow)" }}>
            Wrapped {period.title}
          </div>
        </Zone>
        <Zone at="middle">
          <div data-part="headline" className="abs disp" style={{ left: 66, right: 72, top: 480, fontSize: 200 }}>
            <span className="sr-only">{HEADLINE}</span>
            <span aria-hidden>
              <Letters text={HEADLINE} />
            </span>
          </div>
          <div data-part="why" className="line" style={{ top: 1090 }}>
            You sent fewer than 50 messages, so there's no story about you this time. Here's what the chat got up to.
          </div>
          <div data-part="period" className="kick" style={{ top: 1340, color: "var(--wr-muted)" }}>
            {longDate(period.start)} – {longDate(lastDay(period.end))}
          </div>
        </Zone>
      </Scene>
    </div>
  );
}
